import React, { useState } from "react";
import DealProgress from "./DealProgress";
import Select from "react-select";
import DealService from "../Services/DealService";
import { showSuccessToast, showWarningToast } from "../Constant/Notification";

const DealInfoCard = ({
  dealInfoSelected,

  dealStageSelected,
  userList,
  onReload,
  dealID,
  icons,

  paymentType,
  userRole,
  handleReport,
  handleViewSiteImages,
  handleViewAdvanvcePayment,
  handleOpenSiteVisitHistory,
  handleDealHistory,
  handleDailyUpdateComment,
  setVisibleRight
}) => {

  const bookingPaymentType = {
    h1XYmDM384DMp9V9TjoB: "Cash",
    v4s08PWNt0bJRYMzpap0: "Loan",
    LCIHTCEmTrkKq2qB1yYq: "DD",
    "9rJ39FBvmhkEYvEGpK6L": "OCR-NEFT",
    bdhSiAxe2sLizWGDabhp: "OCR-RTGS",
    "2onjCf7kV9syVVulJP1g": "OCR-IMPS",
    kb9eiMJqQy2dxa7Fg7v8: "Cheque",
    RjI0CAOzeyOBzRqWiKPg: "UPI Transaction",
  };
  const [responseUser, setResponseUser] = useState(userList || []);
  const [selectedResponsible, setSelectedResponsible] = useState(
    dealInfoSelected?.dealFollowup?.responsible?.name || ""
  );
  const [selectedResponsibleId, setSelectedResponsibleId] = useState(
    dealInfoSelected?.dealFollowup?.responsible?.id || ""
  );
  const options = responseUser.map((user) => ({
    value: user.id,
    label: user.name,
  }));
  const handleChange = (selectedOption) => {
    setSelectedResponsibleId(selectedOption?.value || "");
    setSelectedResponsible(selectedOption?.label || "");
  };

  const [previousPersonId , setPreviousPersonId] = useState(dealInfoSelected?.dealFollowup?.responsible?.id || "")

  console.log(selectedResponsible);

  const handleUpdateDeal = async () => {
    const body = {
      uid: selectedResponsibleId,
      dealId: dealID,
    };
    if (previousPersonId === selectedResponsibleId) {
      showWarningToast("Selected person is already assigned. Please choose a different person.");
      return;
    }
    
    try {
      const response = await DealService.updateDealUser(body);
      console.log(response);
      
      showSuccessToast("Responsible person updated successfully.");
      if (onReload) {
        onReload();
      }
      setVisibleRight(false)
    } catch (error) {
      console.log(error);
    }
  };
  console.log("Deal Info Selected: ", dealInfoSelected);

  const PropertyType = dealInfoSelected?.propertyType || "";

  console.log("Pipe Line PropertyType: ", PropertyType);

  return (
    <>
      <b>
        <h2>Deal Card</h2>
      </b>
      <div className="flex items-center">
        <img className="w-5" src={icons.pipelineUserIcon} alt="User" />
        <p className="text-base">{dealInfoSelected?.lead}</p>
      </div>

      <div className="interested-container">
        <span>Interested </span> &nbsp;{" "}
        <div className="tags-container flex flex-wrap">
          {/* {dealInfoSelected?.lead?.interestTags.map((value, index) => (
            <div id={index} className="mr-2 mb-2">
              <span className="ml-1">{value?.name}</span>
            </div>
          ))} */}
        </div>
      </div>

      <div className="deal-stage ">
        {" "}
        <span className="green">Deal Stage: </span>{" "}
        <span>{dealStageSelected}</span>
        <button onClick={handleDealHistory} className="ml-5 text-blue-400">
          (View History)
        </button>
      </div>

      <DealProgress dealStageSelected={dealStageSelected} />

      {dealStageSelected == "Site Visit" ||
      dealStageSelected == "After Site Visit Follow Up" ||
      dealStageSelected == "Sitting" ||
      dealStageSelected == "After Sitting Follow Up" ? (
        <div className="deal-information">
          <div className="text-center underline mb-3">
            <span>Deal Information</span>
          </div>
          <div className="text-center flex justify-center gap-2 mb-3">
            <span>No. of Site Visit: {dealInfoSelected?.siteVistCount}</span>
            <img
              onClick={handleOpenSiteVisitHistory}
              className="w-4 pt-1"
              src={icons.infoIcon}
              alt=""
            />
          </div>
          <form action="" className="w-full ">
            <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Deal Sq Feet
              </label>
              <input
                className="shadow appearance-none font-semibold cursor-default bg-[#F3F3F3] border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                readOnly
                required
                value={dealInfoSelected?.squareFeet}
              />
            </div>

            <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Budget
              </label>
              <input
                className="shadow appearance-none border font-semibold cursor-default bg-[#F3F3F3] rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                required
                readOnly
                value={dealInfoSelected?.budget}
              />
            </div>

            <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Property
              </label>
              <input
                className="shadow appearance-none border font-semibold cursor-default bg-[#F3F3F3] rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                required
                readOnly
                value={dealInfoSelected?.property}
              />
            </div>
          </form>
        </div>
      ) : (
        ""
      )}

      {dealStageSelected === "Plot Booked" ? (
        <div className="deal-information">
          <div className="flex flex-col items-center mt-2 mb-2 text-blue-500 font-normal">
            <p className="cursor-pointer" onClick={handleViewAdvanvcePayment}>
              (View Advance Payment)
            </p>
            <p className="cursor-pointer" onClick={handleDailyUpdateComment}>
              (Daily Update & Comment)
            </p>
          </div>
          <div className="text-center underline mb-3">
            <span>Deal Information</span>
          </div>
          <div className="text-center flex justify-center gap-2 mb-3">
            <span>No. of Site Visit: {dealInfoSelected?.siteVistCount}</span>
            <img
              onClick={handleOpenSiteVisitHistory}
              className="w-4 pt-1"
              src={icons.infoIcon}
              alt=""
            />
          </div>
          <form action="" className="w-full ">
            <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Property
              </label>
              <input
                className="shadow appearance-none border font-semibold cursor-default bg-[#F3F3F3] rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                required
                readOnly
                value={dealInfoSelected?.property}
              />
            </div>

            <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Unit No
              </label>
              <input
                className="shadow appearance-none border font-semibold cursor-default bg-[#F3F3F3] rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                required
                readOnly
                value={dealInfoSelected?.unit}
              />
            </div>

            {PropertyType === "Villa" ? (
              <>
                <div className="mb-8 flex items-center">
                  <label className="w-2/4" htmlFor="name">
                    Saleable Area
                  </label>
                  
                  <input
                    className="shadow appearance-none font-semibold cursor-default bg-[#F3F3F3] border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    id="name"
                    type="text"
                    readOnly
                    required
                    value={dealInfoSelected?.squareFeet}
                  />
                </div>

                <div className="mb-8 flex items-center">
                  <label className="w-2/4" htmlFor="name">
                    Base Rate
                  </label>
                  <input
                    className="shadow appearance-none border font-semibold cursor-default bg-[#F3F3F3] rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    id="name"
                    type="text"
                    required
                    readOnly
                    value={dealInfoSelected?.pricePerSquareFeet}
                  />
                </div>

                <div className="mb-8 flex items-center">
                  <label className="w-2/4" htmlFor="name">
                    Base Price
                  </label>
                  <input
                    className="shadow appearance-none border font-semibold cursor-default bg-[#F3F3F3] rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    id="name"
                    type="text"
                    required
                    readOnly
                    value={(dealInfoSelected?.squareFeet) * (dealInfoSelected?.pricePerSquareFeet)}
                  />
                </div>
              </>
            ) : PropertyType === "Layout" ? (
              <>
              <div className="mb-8 flex items-center">
                  <label className="w-2/4" htmlFor="name">
                    Sq feet
                  </label>
                  
                  <input
                    className="shadow appearance-none font-semibold cursor-default bg-[#F3F3F3] border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    id="name"
                    type="text"
                    readOnly
                    required
                    value={dealInfoSelected?.squareFeet}
                  />
                </div>
                <div className="mb-8 flex items-center">
                  <label className="w-2/4" htmlFor="name">
                    Rate/Sq feet
                  </label>
                  
                  <input
                    className="shadow appearance-none font-semibold cursor-default bg-[#F3F3F3] border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    id="name"
                    type="text"
                    readOnly
                    required
                    value={dealInfoSelected?.pricePerSquareFeet}
                  />
                </div>

                <div className="mb-8 flex items-center">
                  <label className="w-2/4" htmlFor="name">
                    Base Price
                  </label>
                  
                  <input
                    className="shadow appearance-none font-semibold cursor-default bg-[#F3F3F3] border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    id="name"
                    type="text"
                    readOnly
                    required
                    value={ "Rs." +dealInfoSelected?.squareFeet * dealInfoSelected?.pricePerSquareFeet}
                  />
                </div>
              
              </>
            ) : (
            <>
            </>)
          }

            {/* <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Plot Sq Feet
              </label>
              <input
                className="shadow appearance-none font-semibold cursor-default bg-[#F3F3F3] border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                readOnly
                required
                value={dealInfoSelected?.plot?.sqft}
              />
            </div>

            <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Price/Sq.Feet
              </label>
              <input
                className="shadow appearance-none border font-semibold cursor-default bg-[#F3F3F3] rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                required
                readOnly
                value={"Rs. " + dealInfoSelected?.pricePerSquareFeet}
              />
            </div>

            <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Total Amt
              </label>
              <input
                className="shadow appearance-none border font-semibold cursor-default bg-[#F3F3F3] rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                required
                readOnly
                value={"Rs. " + dealInfoSelected?.budget}
              />
            </div> */}

            <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Booking Amt
              </label>
              <input
                className="shadow appearance-none border font-semibold cursor-default bg-[#F3F3F3] rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                required
                readOnly
                value={"Rs. " + dealInfoSelected?.bookingAmount}
              />
            </div>

            <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Booking Amt Type
              </label>

              <input
                className="shadow appearance-none border font-semibold cursor-default bg-[#F3F3F3] rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                required
                readOnly
                value={bookingPaymentType[dealInfoSelected?.bookingPaymentType]}
              />
            </div>

            <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Payment type
              </label>
              <input
                className="shadow appearance-none border font-semibold cursor-default bg-[#F3F3F3] rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                required
                readOnly
                value={dealInfoSelected?.paymentType}
              />
            </div>
          </form>
        </div>
      ) : (
        ""
      )}

      {dealStageSelected === "Advance Amount Update" ? (
        <div className="deal-information">
          <div className="flex flex-col items-center mt-2 mb-2 text-blue-500 font-normal">
            <p className="cursor-pointer" onClick={handleViewAdvanvcePayment}>
              (View Advance Payment)
            </p>
            <p className="cursor-pointer" onClick={handleDailyUpdateComment}>
              (Daily Update & Comment)
            </p>
          </div>
          <span>Deal Information</span>
          <div className="text-center flex justify-center gap-2 mb-3">
            <span>No. of Site Visit: {dealInfoSelected?.siteVistCount}</span>
            <img
              onClick={handleOpenSiteVisitHistory}
              className="w-4 pt-1"
              src={icons.infoIcon}
              alt=""
            />
          </div>
          <form action="" className="w-full ">
            <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Property
              </label>
              <input
                className="shadow appearance-none border font-semibold cursor-default bg-[#F3F3F3] rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                required
                readOnly
                value={dealInfoSelected?.property}
              />
            </div>

            <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Unit No
              </label>
              <input
                className="shadow appearance-none border font-semibold cursor-default bg-[#F3F3F3] rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                required
                readOnly
                value={dealInfoSelected?.unit}
              />
            </div>

            {PropertyType === "Villa" ? (
              <>
                <div className="mb-8 flex items-center">
                  <label className="w-2/4" htmlFor="name">
                    Saleable Area
                  </label>
                  
                  <input
                    className="shadow appearance-none font-semibold cursor-default bg-[#F3F3F3] border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    id="name"
                    type="text"
                    readOnly
                    required
                    value={dealInfoSelected?.squareFeet}
                  />
                </div>

                <div className="mb-8 flex items-center">
                  <label className="w-2/4" htmlFor="name">
                    Base Rate
                  </label>
                  <input
                    className="shadow appearance-none border font-semibold cursor-default bg-[#F3F3F3] rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    id="name"
                    type="text"
                    required
                    readOnly
                    value={dealInfoSelected?.pricePerSquareFeet}
                  />
                </div>

                <div className="mb-8 flex items-center">
                  <label className="w-2/4" htmlFor="name">
                    Base Price
                  </label>
                  <input
                    className="shadow appearance-none border font-semibold cursor-default bg-[#F3F3F3] rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    id="name"
                    type="text"
                    required
                    readOnly
                    value={(dealInfoSelected?.squareFeet) * (dealInfoSelected?.pricePerSquareFeet)}
                  />
                </div>
              </>
            ) : PropertyType === "Layout" ? (
              <>
              <div className="mb-8 flex items-center">
                  <label className="w-2/4" htmlFor="name">
                    Sq feet
                  </label>
                  
                  <input
                    className="shadow appearance-none font-semibold cursor-default bg-[#F3F3F3] border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    id="name"
                    type="text"
                    readOnly
                    required
                    value={dealInfoSelected?.squareFeet}
                  />
                </div>
                <div className="mb-8 flex items-center">
                  <label className="w-2/4" htmlFor="name">
                    Rate/Sq feet
                  </label>
                  
                  <input
                    className="shadow appearance-none font-semibold cursor-default bg-[#F3F3F3] border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    id="name"
                    type="text"
                    readOnly
                    required
                    value={dealInfoSelected?.pricePerSquareFeet}
                  />
                </div>

                <div className="mb-8 flex items-center">
                  <label className="w-2/4" htmlFor="name">
                    Base Price
                  </label>
                  
                  <input
                    className="shadow appearance-none font-semibold cursor-default bg-[#F3F3F3] border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    id="name"
                    type="text"
                    readOnly
                    required
                    value={ "Rs." +dealInfoSelected?.squareFeet * dealInfoSelected?.pricePerSquareFeet}
                  />
                </div>
              
              </>
            ) : (
            <>
            </>)
          }

            {/* <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Plot Sq Feet
              </label>
              <input
                className="shadow appearance-none font-semibold cursor-default bg-[#F3F3F3] border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                readOnly
                required
                value={dealInfoSelected?.plot?.sqft}
              />
            </div>

            <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Price/Sq.Feet
              </label>
              <input
                className="shadow appearance-none border font-semibold cursor-default bg-[#F3F3F3] rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                required
                readOnly
                value={"Rs. " + dealInfoSelected?.pricePerSquareFeet}
              />
            </div>

            <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Total Amt
              </label>
              <input
                className="shadow appearance-none border font-semibold cursor-default bg-[#F3F3F3] rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                required
                readOnly
                value={"Rs. " + dealInfoSelected?.budget}
              />
            </div> */}

            <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Booking Amt
              </label>

              <input
                className="shadow appearance-none border font-semibold cursor-default bg-[#F3F3F3] rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                required
                readOnly
                value={"Rs. " + dealInfoSelected?.bookingAmount}
              />
            </div>
            <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Booking Amt Type
              </label>

              <input
  className="shadow appearance-none border font-semibold cursor-default bg-[#F3F3F3] rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
  id="name"
  type="text"
  required
  readOnly
  value={
    bookingPaymentType && dealInfoSelected?.bookingPaymentType
      ? bookingPaymentType[dealInfoSelected.bookingPaymentType] || ""
      : ""
  }
/>

            </div>
            <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Payment type
              </label>
              <input
                className="shadow appearance-none border font-semibold cursor-default bg-[#F3F3F3] rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                required
                readOnly
                value={dealInfoSelected?.paymentType || "-"}
              />
            </div>
          </form>
        </div>
      ) : (
        ""
      )}

      {dealStageSelected == "Registration InProgress" ? (
        <div className="deal-information">
          <div className="flex flex-col items-center mt-2 mb-2 text-blue-500 font-normal">
            <p className="cursor-pointer" onClick={handleViewAdvanvcePayment}>
              (View Advance Payment)
            </p>
            <p className="cursor-pointer" onClick={handleDailyUpdateComment}>
              (Daily Update & Comment)
            </p>
          </div>
          <div className="text-center flex flex-col">
            <span className="underline">Deal Information</span>
            {(userRole === "Admin" || userRole === "CMO") && (
              <span
                className="text-blue-500 font-normal cursor-pointer"
                onClick={handleReport}
              >
                Get Cost Sheet
              </span>
            )}
          </div>
          <div className="text-center flex justify-center gap-2 mb-3">
            <span>No. of Site Visit: {dealInfoSelected?.siteVistCount}</span>
            <img
              onClick={handleOpenSiteVisitHistory}
              className="w-4 pt-1"
              src={icons.infoIcon}
              alt=""
            />
          </div>
          <form action="" className="w-full ">
            <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Property
              </label>
              <input
                className="shadow appearance-none border font-semibold cursor-default bg-[#F3F3F3] rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                required
                readOnly
                value={dealInfoSelected?.property}
              />
            </div>

            <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Unit No
              </label>
              <input
                className="shadow appearance-none border font-semibold cursor-default bg-[#F3F3F3] rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                required
                readOnly
                value={dealInfoSelected?.unit}
              />
            </div>

            {PropertyType === "Villa" ? (
              <>
                <div className="mb-8 flex items-center">
                  <label className="w-2/4" htmlFor="name">
                    Saleable Area
                  </label>
                  
                  <input
                    className="shadow appearance-none font-semibold cursor-default bg-[#F3F3F3] border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    id="name"
                    type="text"
                    readOnly
                    required
                    value={dealInfoSelected?.squareFeet}
                  />
                </div>

                <div className="mb-8 flex items-center">
                  <label className="w-2/4" htmlFor="name">
                    Base Rate
                  </label>
                  <input
                    className="shadow appearance-none border font-semibold cursor-default bg-[#F3F3F3] rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    id="name"
                    type="text"
                    required
                    readOnly
                    value={dealInfoSelected?.pricePerSquareFeet}
                  />
                </div>

                <div className="mb-8 flex items-center">
                  <label className="w-2/4" htmlFor="name">
                    Base Price
                  </label>
                  <input
                    className="shadow appearance-none border font-semibold cursor-default bg-[#F3F3F3] rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    id="name"
                    type="text"
                    required
                    readOnly
                    value={(dealInfoSelected?.squareFeet) * (dealInfoSelected?.pricePerSquareFeet)}
                  />
                </div>
              </>
            ) : PropertyType === "Layout" ? (
              <>
              <div className="mb-8 flex items-center">
                  <label className="w-2/4" htmlFor="name">
                    Sq feet
                  </label>
                  
                  <input
                    className="shadow appearance-none font-semibold cursor-default bg-[#F3F3F3] border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    id="name"
                    type="text"
                    readOnly
                    required
                    value={dealInfoSelected?.squareFeet}
                  />
                </div>
                <div className="mb-8 flex items-center">
                  <label className="w-2/4" htmlFor="name">
                    Rate/Sq feet
                  </label>
                  
                  <input
                    className="shadow appearance-none font-semibold cursor-default bg-[#F3F3F3] border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    id="name"
                    type="text"
                    readOnly
                    required
                    value={dealInfoSelected?.pricePerSquareFeet}
                  />
                </div>

                <div className="mb-8 flex items-center">
                  <label className="w-2/4" htmlFor="name">
                    Base Price
                  </label>
                  
                  <input
                    className="shadow appearance-none font-semibold cursor-default bg-[#F3F3F3] border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    id="name"
                    type="text"
                    readOnly
                    required
                    value={ "Rs." +dealInfoSelected?.squareFeet * dealInfoSelected?.pricePerSquareFeet}
                  />
                </div>
              
              </>
            ) : (
            <>
            </>)
          }

            {/* <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Plot Sq Feet
              </label>
              <input
                className="shadow appearance-none font-semibold cursor-default bg-[#F3F3F3] border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                readOnly
                required
                value={dealInfoSelected?.plot?.sqft}
              />
            </div>

            <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Price/Sq.Feet
              </label>
              <input
                className="shadow appearance-none border font-semibold cursor-default bg-[#F3F3F3] rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                required
                readOnly
                value={"Rs. " + dealInfoSelected?.pricePerSquareFeet}
              />
            </div>

            <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Total Amt
              </label>
              <input
                className="shadow appearance-none border font-semibold cursor-default bg-[#F3F3F3] rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                required
                readOnly
                value={"Rs. " + dealInfoSelected?.budget}
              />
            </div> */}

            <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Booking Amt
              </label>
              <input
                className="shadow appearance-none border font-semibold cursor-default bg-[#F3F3F3] rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                required
                readOnly
                value={"Rs. " + dealInfoSelected?.bookingAmount}
              />
            </div>
            <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Booking Amt Type
              </label>

              <input
                className="shadow appearance-none border font-semibold cursor-default bg-[#F3F3F3] rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                required
                readOnly
                value={bookingPaymentType[dealInfoSelected?.bookingPaymentType]}
              />
            </div>
            <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Payment Type
              </label>
              <input
                className="shadow appearance-none border font-semibold cursor-default bg-[#F3F3F3] rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                required
                readOnly
                value={dealInfoSelected.paymentType}
                // value={paymentType[dealInfoSelected?.paymentType]}
              />
            </div>
          </form>
        </div>
      ) : (
        ""
      )}

      {dealStageSelected == "Fully Registered" ? (
        <div className="deal-information">
          <div className="flex flex-col items-center mt-2 mb-2 text-blue-500 font-normal">
            <p className="cursor-pointer" onClick={handleViewAdvanvcePayment}>
              (View Advance Payment)
            </p>
            <p className="cursor-pointer" onClick={handleDailyUpdateComment}>
              (Daily Update & Comment)
            </p>
          </div>
          {/* <span className="text-center">Deal Information</span> */}
          <div className="text-center flex flex-col">
            <span className="underline">Deal Information</span>
            {(userRole === "Admin" || userRole === "CMO") && (
              <span
                className="text-blue-500 font-normal cursor-pointer"
                onClick={handleReport}
              >
                Get Cost Sheet
              </span>
            )}
          </div>
          <div className="text-center flex justify-center gap-2 mb-3">
            <span>No. of Site Visit: {dealInfoSelected?.siteVistCount}</span>
            <img
              onClick={handleOpenSiteVisitHistory}
              className="w-4 pt-1"
              src={icons.infoIcon}
              alt=""
            />
          </div>
          <form action="" className="w-full ">
            <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Property
              </label>
              <input
                className="shadow appearance-none border font-semibold cursor-default bg-[#F3F3F3] rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                required
                readOnly
                value={dealInfoSelected?.property}
              />
            </div>

            <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Unit No
              </label>
              <input
                className="shadow appearance-none border font-semibold cursor-default bg-[#F3F3F3] rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                required
                readOnly
                value={dealInfoSelected?.unit}
              />
            </div>

            {PropertyType === "Villa" ? (
              <>
                <div className="mb-8 flex items-center">
                  <label className="w-2/4" htmlFor="name">
                    Saleable Area
                  </label>
                  
                  <input
                    className="shadow appearance-none font-semibold cursor-default bg-[#F3F3F3] border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    id="name"
                    type="text"
                    readOnly
                    required
                    value={dealInfoSelected?.squareFeet}
                  />
                </div>

                <div className="mb-8 flex items-center">
                  <label className="w-2/4" htmlFor="name">
                    Base Rate
                  </label>
                  <input
                    className="shadow appearance-none border font-semibold cursor-default bg-[#F3F3F3] rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    id="name"
                    type="text"
                    required
                    readOnly
                    value={dealInfoSelected?.pricePerSquareFeet}
                  />
                </div>

                <div className="mb-8 flex items-center">
                  <label className="w-2/4" htmlFor="name">
                    Base Price
                  </label>
                  <input
                    className="shadow appearance-none border font-semibold cursor-default bg-[#F3F3F3] rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    id="name"
                    type="text"
                    required
                    readOnly
                    value={(dealInfoSelected?.squareFeet) * (dealInfoSelected?.pricePerSquareFeet)}
                  />
                </div>
              </>
            ) : PropertyType === "Layout" ? (
              <>
              <div className="mb-8 flex items-center">
                  <label className="w-2/4" htmlFor="name">
                    Sq feet
                  </label>
                  
                  <input
                    className="shadow appearance-none font-semibold cursor-default bg-[#F3F3F3] border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    id="name"
                    type="text"
                    readOnly
                    required
                    value={dealInfoSelected?.squareFeet}
                  />
                </div>
                <div className="mb-8 flex items-center">
                  <label className="w-2/4" htmlFor="name">
                    Rate/Sq feet
                  </label>
                  
                  <input
                    className="shadow appearance-none font-semibold cursor-default bg-[#F3F3F3] border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    id="name"
                    type="text"
                    readOnly
                    required
                    value={dealInfoSelected?.pricePerSquareFeet}
                  />
                </div>

                <div className="mb-8 flex items-center">
                  <label className="w-2/4" htmlFor="name">
                    Base Price
                  </label>
                  
                  <input
                    className="shadow appearance-none font-semibold cursor-default bg-[#F3F3F3] border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    id="name"
                    type="text"
                    readOnly
                    required
                    value={ "Rs." +dealInfoSelected?.squareFeet * dealInfoSelected?.pricePerSquareFeet}
                  />
                </div>
              
              </>
            ) : (
            <>
            </>)
          }

            {/* <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Plot Sq Feet
              </label>
              <input
                className="shadow appearance-none font-semibold cursor-default bg-[#F3F3F3] border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                readOnly
                required
                value={dealInfoSelected?.plot?.sqft}
              />
            </div>

            <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Price/Sq.Feet
              </label>
              <input
                className="shadow appearance-none border font-semibold cursor-default bg-[#F3F3F3] rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                required
                readOnly
                value={"Rs. " + dealInfoSelected?.pricePerSquareFeet}
              />
            </div>

            <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Total Amt
              </label>
              <input
                className="shadow appearance-none border font-semibold cursor-default bg-[#F3F3F3] rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                required
                readOnly
                value={"Rs. " + dealInfoSelected?.budget}
              />
            </div> */}

            <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Booking Amt
              </label>
              <input
                className="shadow appearance-none border font-semibold cursor-default bg-[#F3F3F3] rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                required
                readOnly
                value={"Rs. " + dealInfoSelected?.bookingAmount}
              />
            </div>

            <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Payment Type
              </label>
              <input
                className="shadow appearance-none border font-semibold cursor-default bg-[#F3F3F3] rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                required
                readOnly
                value={dealInfoSelected?.paymentType || "-"}
              />
            </div>
          </form>
        </div>
      ) : (
        ""
      )}

      {dealStageSelected === "Deal Lost Before Booking" ? (
        <div className="deal-information">
          <div className="text-center my-5">
            <span className="underline">Deal Lost Information</span>
          </div>
          <div className="text-center flex justify-center gap-2 mb-3">
            <span>No. of Site Visit: {dealInfoSelected?.siteVistCount}</span>
            <img
              onClick={handleOpenSiteVisitHistory}
              className="w-4 pt-1"
              src={icons.infoIcon}
              alt=""
            />
          </div>
          <form action="" className="w-full ">
            <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Deal Sq Feet
              </label>
              <input
                className="shadow appearance-none font-semibold cursor-default bg-[#F3F3F3] border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                readOnly
                required
                value={dealInfoSelected?.squareFeet}
              />
            </div>
            <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Budget
              </label>
              <input
                className="shadow appearance-none border font-semibold cursor-default bg-[#F3F3F3] rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                required
                readOnly
                value={"Rs. " + dealInfoSelected?.budget}
              />
            </div>
            <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Property
              </label>
              <input
                className="shadow appearance-none border font-semibold cursor-default bg-[#F3F3F3] rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                required
                readOnly
                value={dealInfoSelected?.property}
              />
            </div>

            <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Reason For Deal Lost
              </label>
              <textarea
                className="shadow appearance-none border font-semibold cursor-default bg-[#F3F3F3] h-40 overflow-y-auto custom-scrollbar rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                required
                readOnly
                value={
                  dealInfoSelected?.reasonForDealLost
                    ? dealInfoSelected?.reasonForDealLost
                    : ""
                }
              />
            </div>
          </form>
        </div>
      ) : (
        ""
      )}
      {dealStageSelected === "Deal Lost After Booking" ? (
        <div className="deal-information">
          <div className="flex flex-col items-center mt-2 mb-2 text-blue-500 font-normal">
            <p className="cursor-pointer" onClick={handleViewAdvanvcePayment}>
              (View Advance Payment)
            </p>
            <p className="cursor-pointer" onClick={handleDailyUpdateComment}>
              (Daily Update & Comment)
            </p>
          </div>
          <div className="text-center my-3">
            <span className="underline flex flex-col">
              Deal Lost Information
            </span>

            {(userRole === "Admin" || userRole === "CMO") && (
              <span
                className="text-blue-500 font-normal cursor-pointer"
                onClick={handleReport}
              >
                Get Cost Sheet
              </span>
            )}
            <div className="text-center flex justify-center gap-2 mb-3">
              <span>No. of Site Visit: {dealInfoSelected?.siteVistCount}</span>
              <img
                onClick={handleOpenSiteVisitHistory}
                className="w-4 pt-1"
                src={icons.infoIcon}
                alt=""
              />
            </div>
          </div>

          <form action="" className="w-full ">
            <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Cancel Side
              </label>
              <input
                className="shadow appearance-none border font-semibold cursor-default bg-[#F3F3F3] rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                required
                readOnly
                value={dealInfoSelected?.cancelSide}
              />
            </div>

            <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Reason For Deal Lost
              </label>
              <textarea
                className="shadow appearance-none border font-semibold cursor-default bg-[#F3F3F3] rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                required
                readOnly
                value={
                  dealInfoSelected?.reasonForDealLost
                    ? dealInfoSelected?.reasonForDealLost
                    : ""
                }
              />
            </div>
          </form>
          <div className="text-center my-3">
            <span className="underline">Other Deal Information</span>
          </div>

          <form action="" className="w-full ">
            <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Property
              </label>
              <input
                className="shadow appearance-none border font-semibold cursor-default bg-[#F3F3F3] rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                required
                readOnly
                value={dealInfoSelected?.property}
              />
            </div>

            <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Unit No
              </label>
              <input
                className="shadow appearance-none border font-semibold cursor-default bg-[#F3F3F3] rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                required
                readOnly
                value={dealInfoSelected?.unit}
              />
            </div>

            {PropertyType === "Villa" ? (
              <>
                <div className="mb-8 flex items-center">
                  <label className="w-2/4" htmlFor="name">
                    Saleable Area
                  </label>
                  
                  <input
                    className="shadow appearance-none font-semibold cursor-default bg-[#F3F3F3] border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    id="name"
                    type="text"
                    readOnly
                    required
                    value={dealInfoSelected?.squareFeet}
                  />
                </div>

                <div className="mb-8 flex items-center">
                  <label className="w-2/4" htmlFor="name">
                    Base Rate
                  </label>
                  <input
                    className="shadow appearance-none border font-semibold cursor-default bg-[#F3F3F3] rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    id="name"
                    type="text"
                    required
                    readOnly
                    value={dealInfoSelected?.pricePerSquareFeet}
                  />
                </div>

                <div className="mb-8 flex items-center">
                  <label className="w-2/4" htmlFor="name">
                    Base Price
                  </label>
                  <input
                    className="shadow appearance-none border font-semibold cursor-default bg-[#F3F3F3] rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    id="name"
                    type="text"
                    required
                    readOnly
                    value={(dealInfoSelected?.squareFeet) * (dealInfoSelected?.pricePerSquareFeet)}
                  />
                </div>
              </>
            ) : PropertyType === "Layout" ? (
              <>
              <div className="mb-8 flex items-center">
                  <label className="w-2/4" htmlFor="name">
                    Sq feet
                  </label>
                  
                  <input
                    className="shadow appearance-none font-semibold cursor-default bg-[#F3F3F3] border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    id="name"
                    type="text"
                    readOnly
                    required
                    value={dealInfoSelected?.squareFeet}
                  />
                </div>
                <div className="mb-8 flex items-center">
                  <label className="w-2/4" htmlFor="name">
                    Rate/Sq feet
                  </label>
                  
                  <input
                    className="shadow appearance-none font-semibold cursor-default bg-[#F3F3F3] border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    id="name"
                    type="text"
                    readOnly
                    required
                    value={dealInfoSelected?.pricePerSquareFeet}
                  />
                </div>

                <div className="mb-8 flex items-center">
                  <label className="w-2/4" htmlFor="name">
                    Base Price
                  </label>
                  
                  <input
                    className="shadow appearance-none font-semibold cursor-default bg-[#F3F3F3] border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    id="name"
                    type="text"
                    readOnly
                    required
                    value={ "Rs." +dealInfoSelected?.squareFeet * dealInfoSelected?.pricePerSquareFeet}
                  />
                </div>
              
              </>
            ) : (
            <>
            </>)
          }

            {/* <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Plot Sq Feet
              </label>
              <input
                className="shadow appearance-none font-semibold cursor-default bg-[#F3F3F3] border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                readOnly
                required
                value={dealInfoSelected?.plot?.sqft}
              />
            </div>

            <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Price/Sq.Feet
              </label>
              <input
                className="shadow appearance-none border font-semibold cursor-default bg-[#F3F3F3] rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                required
                readOnly
                value={
                  "Rs. " + dealInfoSelected?.pricePerSquareFeet
                    ? dealInfoSelected?.pricePerSquareFeet
                    : ""
                }
              />
            </div>

            <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Total Amt
              </label>
              <input
                className="shadow appearance-none border font-semibold cursor-default bg-[#F3F3F3] rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                required
                readOnly
                value={
                  "Rs. " +
                  String(
                    dealInfoSelected?.budget ? dealInfoSelected?.budget : ""
                  )
                }
              />
            </div> */}

            <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Booking Amt
              </label>
              <input
                className="shadow appearance-none border font-semibold cursor-default bg-[#F3F3F3] rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                required
                readOnly
                value={
                  "Rs. " + dealInfoSelected?.bookingAmount
                    ? dealInfoSelected?.bookingAmount
                    : ""
                }
              />
            </div>

            <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Payment Type
              </label>
              <input
                className="shadow appearance-none border font-semibold cursor-default bg-[#F3F3F3] rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                required
                readOnly
                value={dealInfoSelected?.paymentType}
              />
            </div>
          </form>
        </div>
      ) : (
        ""
      )}

      {dealStageSelected == "Site Visit" ? (
        <div className="visit-container">
          <div className="text-center">
            <span className="underline">Scheduled Site Visit</span>
          </div>

          <form action="" className="w-full ">
            <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Property
              </label>
              <input
                className="shadow appearance-none font-semibold cursor-default bg-[#F3F3F3] border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                readOnly
                required
                value={dealInfoSelected?.property}
              />
            </div>

            <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Visit Date & Time
              </label>
              <input
                className="shadow appearance-none border font-semibold cursor-default bg-[#F3F3F3] rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                required
                readOnly
                value={dealInfoSelected?.dealFollowup?.scheduledTime}
              />
            </div>

            {
              <div className="mb-8 flex items-center">
                <label className="w-2/4" htmlFor="name">
                  Responsible
                </label>
                <Select
                  options={options}
                  onChange={handleChange}
                  value={
                    options.find(
                      (opt) => opt.value === selectedResponsibleId
                    ) || null
                  }
                  placeholder="-- Select a user --"
                  isClearable
                  className="w-3/4 font-semibold bg-[#F3F3F3] text-gray-700"
                />
              </div>
            }
          </form>
        </div>
      ) : (
        ""
      )}

      {dealStageSelected == "After Site Visit Follow Up" ? (
        <div className="visit-container">
          <div className="text-center">
            <span className="underline">
              Scheduled After Site Visit Follow Up
            </span>
          </div>

          <form action="" className="w-full ">
            {/* <div className="mb-8 flex items-center">
                 <label className="w-2/4" htmlFor="name">
                   Property
                 </label>
                 <input
                   className="shadow appearance-none font-semibold cursor-default bg-[#F3F3F3] border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                   id="name"
                   type="text"
                   readOnly
                   required
                   value={dealInfoSelected?.property}
                 />
               </div> */}

            <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Visit Date & Time
              </label>
              <input
                className="shadow appearance-none border font-semibold cursor-default bg-[#F3F3F3] rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                required
                readOnly
                value={dealInfoSelected?.dealFollowup?.scheduledTime}
              />
            </div>

            <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Responsible
              </label>
              <Select
                options={options}
                onChange={handleChange}
                value={
                  options.find((opt) => opt.value === selectedResponsibleId) ||
                  null
                }
                placeholder="-- Select a user --"
                isClearable
                className="w-3/4 font-semibold bg-[#F3F3F3] text-gray-700"
              />
            </div>
          </form>
        </div>
      ) : (
        ""
      )}

      {dealStageSelected == "Sitting" ? (
        <div className="visit-container">
          <div className="text-center">
            <span className="underline">Scheduled Sitting</span>
          </div>
          <form action="" className="w-full ">
            <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Property
              </label>
              <input
                className="shadow appearance-none font-semibold cursor-default bg-[#F3F3F3] border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                readOnly
                required
                value={dealInfoSelected?.property}
              />
            </div>

            <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Visit Date & Time
              </label>
              <input
                className="shadow appearance-none border font-semibold cursor-default bg-[#F3F3F3] rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                required
                readOnly
                value={dealInfoSelected?.dealFollowup?.scheduledTime}
              />
            </div>

            <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Responsible
              </label>
              <Select
                options={options}
                onChange={handleChange}
                value={
                  options.find((opt) => opt.value === selectedResponsibleId) ||
                  null
                }
                placeholder="-- Select a user --"
                isClearable
                className="w-3/4 font-semibold bg-[#F3F3F3] text-gray-700"
              />
            </div>
          </form>
        </div>
      ) : (
        ""
      )}

      {dealStageSelected == "After Sitting Follow Up" ? (
        <div className="visit-container">
          <div className="text-center">
            <span className="underline">Scheduled After Sitting Follow Up</span>
          </div>
          <form action="" className="w-full ">
            <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Property
              </label>
              <input
                className="shadow appearance-none font-semibold cursor-default bg-[#F3F3F3] border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                readOnly
                required
                value={dealInfoSelected?.property}
              />
            </div>

            <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Visit Date & Time
              </label>
              <input
                className="shadow appearance-none border font-semibold cursor-default bg-[#F3F3F3] rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                required
                readOnly
                value={dealInfoSelected?.dealFollowup?.scheduledTime}
              />
            </div>

            <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Responsible
              </label>
              <Select
                options={options}
                onChange={handleChange}
                value={
                  options.find((opt) => opt.value === selectedResponsibleId) ||
                  null
                }
                placeholder="-- Select a user --"
                isClearable
                className="w-3/4 font-semibold bg-[#F3F3F3] text-gray-700"
              />
            </div>
          </form>
        </div>
      ) : (
        ""
      )}

      {dealStageSelected == "Plot Booked" ? (
        <div className="visit-container">
          <div className="text-center">
            <span className="underline">Scheduled Plot Booked</span>
          </div>
          <form action="" className="w-full ">
            <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Advance Amount
              </label>
              <input
                className="shadow appearance-none font-semibold cursor-default bg-[#F3F3F3] border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                readOnly
                required
                value={
                  "Rs. " + dealInfoSelected?.dealFollowup?.amountToBeReceived
                }
              />
            </div>

            <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Date & Time
              </label>
              <input
                className="shadow appearance-none border font-semibold cursor-default bg-[#F3F3F3] rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                required
                readOnly
                value={dealInfoSelected?.dealFollowup?.scheduledTime}
              />
            </div>

            <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Responsible
              </label>
              <Select
                options={options}
                onChange={handleChange}
                value={
                  options.find((opt) => opt.value === selectedResponsibleId) ||
                  null
                }
                placeholder="-- Select a user --"
                isClearable
                className="w-3/4 font-semibold bg-[#F3F3F3] text-gray-700"
              />
            </div>
          </form>
        </div>
      ) : (
        ""
      )}
      {dealStageSelected == "Advance Amount Update" ? (
        <div className="visit-container">
          <div className="text-center">
            <span className="underline">Scheduled Advance Amount Update</span>
          </div>
          <form action="" className="w-full ">
            <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Title
              </label>
              <input
                className="shadow appearance-none font-semibold cursor-default bg-[#F3F3F3] border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                readOnly
                required
                value={dealInfoSelected.dealFollowup?.title}
              />
            </div>
            <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Advance Amount
              </label>
              <input
                className="shadow appearance-none font-semibold cursor-default bg-[#F3F3F3] border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                readOnly
                required
                value={dealInfoSelected?.dealFollowup?.amountToBeReceived}
              />
            </div>

            <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Date & Time
              </label>
              <input
                className="shadow appearance-none border font-semibold cursor-default bg-[#F3F3F3] rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                required
                readOnly
                value={dealInfoSelected?.dealFollowup?.scheduledTime}
              />
            </div>

            <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Responsible
              </label>
              <Select
                options={options}
                onChange={handleChange}
                value={
                  options.find((opt) => opt.value === selectedResponsibleId) ||
                  null
                }
                placeholder="-- Select a user --"
                isClearable
                className="w-3/4 font-semibold bg-[#F3F3F3] text-gray-700"
              />
            </div>
          </form>
        </div>
      ) : (
        ""
      )}

      {dealStageSelected == "Registration InProgress" ? (
        <div className="visit-container">
          <div className="text-center">
            <span className="underline">Scheduled Registration InProgress</span>
          </div>
          <form action="" className="w-full ">
            <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Date & Time
              </label>
              <input
                className="shadow appearance-none border font-semibold cursor-default bg-[#F3F3F3] rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                required
                readOnly
                value={dealInfoSelected?.dealFollowup?.scheduledTime}
              />
            </div>

            <div className="mb-8 flex items-center">
              <label className="w-2/4" htmlFor="name">
                Responsible
              </label>
              <Select
                options={options}
                onChange={handleChange}
                value={
                  options.find((opt) => opt.value === selectedResponsibleId) ||
                  null
                }
                placeholder="-- Select a user --"
                isClearable
                className="w-3/4 font-semibold bg-[#F3F3F3] text-gray-700"
              />
            </div>
          </form>
        </div>
      ) : (
        ""
      )}
      {dealInfoSelected?.dealFollowup?.completed ? (
        ""
      ) : (
        <div>
          {dealStageSelected == "Deal Lost After Booking" ? (
            <div className="visit-container-deal-lost-after-booking">
              <div className="text-center">
                <span className="underline">Scheduled Amount Return Date</span>
              </div>
              <form action="" className="w-full ">
                <div className="mb-8 flex items-center">
                  <label className="w-2/4" htmlFor="name">
                    Date & Time
                  </label>
                  <input
                    className="shadow appearance-none border font-semibold cursor-default bg-[#F3F3F3] rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    id="name"
                    type="text"
                    required
                    readOnly
                    value={dealInfoSelected?.dealFollowup?.scheduledTime}
                  />
                </div>

                <div className="mb-8 flex items-center">
                  <label className="w-2/4" htmlFor="name">
                    Responsible
                  </label>
                  <Select
                    options={options}
                    onChange={handleChange}
                    value={
                      options.find(
                        (opt) => opt.value === selectedResponsibleId
                      ) || null
                    }
                    placeholder="-- Select a user --"
                    isClearable
                    className="w-3/4 font-semibold bg-[#F3F3F3] text-gray-700"
                  />
                </div>
              </form>
            </div>
          ) : (
            ""
          )}
        </div>
      )}

      {dealStageSelected !== "Fully Registered" &&
      dealStageSelected !== "Deal Lost Before Booking" ? (
        <div className="flex items-center justify-center mt-3">
          <button
            onClick={handleUpdateDeal}
            className="bg-customGreen px-3 py-1 text-white rounded-md w-20"
          >
            Update
          </button>
        </div>
      ) : null}

      <div className="flex justify-center items-center mt-7 ">
        <span
          onClick={() => handleViewSiteImages(dealID)}
          className="text-blue-500 cursor-pointer font-semibold underline"
        >
          View Site Visit Images
        </span>
      </div>
      <div className="associated">
        <h2>Associations</h2>
        <div className="associations-container">
          <ul>
            {dealInfoSelected?.associatedUsers?.map((val, index) => (
              <li key={index}>
                {val.name} {`(${val?.role})`}
              </li>
            ))}
          </ul>
        </div>
      </div>
      {dealStageSelected === "Site Visit" ? (
        <div className="hidden"></div>
      ) : dealStageSelected === "After Site Visit Follow Up" ? (
        <div className="hidden">
          <h2>Credited Users</h2>
        </div>
      ) : dealStageSelected === "Sitting" ? (
        <div className="hidden"></div>
      ) : dealStageSelected === "After Sitting Follow Up" ? (
        <div className="hidden"></div>
      ) : dealStageSelected === "Deal Lost Before Booking" ? (
        <div className="hidden"></div>
      ) : (
        <div className="associated">
          <h2>Credited Users</h2>
          <div className="associations-container">
            <ul>
              {dealInfoSelected?.creditedUsers?.map((val, index) => (
                <li key={index}>{val.name}{val?.role}</li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </>
  );
};

export default DealInfoCard;
